import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import styled from 'styled-components';
import { mediaMin, tabletRange } from '@spa/shared/theme';
import { Wrapper as Placeholder } from '@spa/shared/components/Unisystem/Placeholder/styles';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-16mjnzn-0"
})(["display:flex;flex-direction:column;", " ", ""], tabletRange.ipad()(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return theme.space(8);
}), mediaMin.largeBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(10, 'column');
}));
export var UnitType = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-16mjnzn-1"
})(["display:flex;align-items:flex-start;justify-content:space-between;", ";padding:0 ", " ", ";", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(30);
}, function (props) {
  return props.theme.space(33);
}, function (props) {
  return props.theme.space(8);
}, mediaMin.largeBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    width: 100%;\n    ", ";\n    padding: 0 ", " ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(5, 'column');
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}));
export var UnitTitle = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-16mjnzn-2"
})(["width:fit-content;font-size:", ";line-height:", ";font-weight:600;position:sticky;top:0;", ""], function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.rem(40);
}, mediaMin.largeBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    position: relative;\n  "]))));
export var Photos = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-16mjnzn-3"
})(["display:flex;flex-direction:column;", ";width:70%;", "{width:100%;height:100%;min-height:480px;transition:transform 0.3s ease-in-out;cursor:pointer;&:hover{transform:scale(1.01);}", "}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(5, 'column');
}, Placeholder, mediaMin.largeBreakpoint(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      min-height: 260px;\n    "]))), mediaMin.largeBreakpoint(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))));
export var PhotosGroup = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-16mjnzn-4"
})(["width:100%;&.horizontal-horizontal-horizontal{display:grid;grid-area:3 / 1;grid-gap:", ";img:nth-child(1){grid-area:1 / 2 / span 2;}img:nth-child(2){grid-area:1 / 1;}img:nth-child(3){grid-area:2 / 1;}}&.vertical-vertical-vertical{display:grid;grid-template-columns:1fr 1fr 1fr;grid-gap:", ";img:nth-child(1){grid-area:1 / 1 / span 2 / span 2;}img:nth-child(2){grid-area:1 / 3;}img:nth-child(3){grid-area:2 / 3;}}&.vertical-horizontal-horizontal{display:grid;grid-area:3 / 1;grid-gap:", ";grid-template-columns:1fr 1fr;img:nth-child(1){grid-area:1 / 1 / span 2;}img:nth-child(2){grid-area:1 / 2;}img:nth-child(3){grid-area:2 / 2;}}&.horizontal-horizontal-vertical{display:grid;grid-area:3 / 1;grid-gap:", ";img:nth-child(1){grid-area:1 / 1;}img:nth-child(2){grid-area:2 / 1;}img:nth-child(3){grid-area:1 / 2 / span 2;}}&.vertical-horizontal{display:grid;grid-template-columns:1fr 2fr;grid-gap:", ";}&.horizontal-vertical{display:grid;grid-template-columns:2fr 1fr;grid-gap:", ";}&.vertical-vertical,&.horizontal-horizontal{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:", ";}&.vertical:has(> &:only-child){width:calc(50% - 10px);", " &{display:flex;}}", ""], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, mediaMin.largeBreakpoint(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      width: 100%;\n    "]))), mediaMin.largeBreakpoint(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex !important;\n    flex-direction: column !important;\n    ", ";\n  "])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.gap(10, 'column');
}));
export var Photo = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-16mjnzn-5"
})(["width:100%;height:100%;object-fit:cover;border-radius:12px;transition:transform 0.3s ease-in-out;cursor:pointer;&:hover{transform:scale(1.01);}"]);